import { useTranslation } from "react-i18next";
import { MdFlight } from "react-icons/md";
import { VoucherCard } from "dds4/components/VoucherCard/v1/VoucherCard";
import { getCssVar } from "src/utility";
import BarcodeDecor from "./Barcode";

const WIDTH = 350;
const HEIGHT = 260;
const FOOTER_HEIGHT = 72;
const DIVIDER_Y = HEIGHT - FOOTER_HEIGHT;
const NOTCH_RADIUS = 8;
const NOTCHES = [
  { position: { x: 0, y: DIVIDER_Y }, radius: NOTCH_RADIUS },
  { position: { x: WIDTH, y: DIVIDER_Y }, radius: NOTCH_RADIUS },
];

const dividerLines = (w: number) => [
  {
    from: { x: NOTCH_RADIUS + 8, y: DIVIDER_Y },
    to: { x: w - NOTCH_RADIUS - 8, y: DIVIDER_Y },
    style: "dashed" as const,
    color: getCssVar("--color-border-default"),
    width: 1,
  },
];

export default function Ticket() {
  const { t } = useTranslation();
  return (
    <div className="flex drop-shadow-lg" aria-hidden={true}>
      <VoucherCard
        fillColor="var(--color-background-default)"
        strokeWidth={.1}
        borderRadius={16}
        notches={NOTCHES}
        lines={dividerLines}
        style={{ width: WIDTH, height: HEIGHT }}
      >
        <div className="flex flex-col font-poppins" style={{ height: HEIGHT }}>
          <div className="flex h-11 shrink-0 items-center justify-between rounded-t-2xl bg-background-primary px-5 text-white">
            <div className="text-xs font-semibold uppercase tracking-widest">{t("Landing.decor.ticket.label")}</div>
            <MdFlight className="size-5 rotate-45" />
          </div>
          <div className="flex flex-1 flex-col justify-between px-5 pt-4 pb-3">
            <div className="flex items-start justify-between gap-3">
              <div className="flex flex-col">
                <span className="text-4xl font-bold">CAI</span>
                <span className="text-xs">{t("Landing.decor.ticket.origin")}</span>
              </div>
              <div className="mt-5 flex-1 border-t-2 border-dotted border-border-default" />
              <div className="flex flex-col items-end">
                <span className="text-4xl font-bold">DXB</span>
                <span className="text-xs">{t("Landing.decor.ticket.destination")}</span>
              </div>
            </div>
            <div className="flex items-end justify-between">
              <div className="flex flex-col">
                <span className="text-xs uppercase tracking-widest">{t("Landing.decor.ticket.date")}</span>
                <span className="text-sm font-semibold">{t("Landing.decor.ticket.dateValue")}</span>
              </div>
              <div className="flex flex-col items-center">
                <span className="text-xs uppercase tracking-widest">{t("Landing.decor.ticket.class")}</span>
                <span className="text-sm font-semibold">{t("Landing.decor.ticket.classValue")}</span>
              </div>
              <div className="flex flex-col items-end">
                <span className="text-xs uppercase tracking-widest">{t("Landing.decor.ticket.seat")}</span>
                <span className="text-sm font-semibold">14A</span>
              </div>
            </div>
          </div>
          <div className="flex shrink-0 items-center justify-between px-5" style={{ height: FOOTER_HEIGHT }}>
            <BarcodeDecor/>
            <div className="flex flex-col items-start">
              <span className="text-xs uppercase tracking-widest">{t("Landing.decor.paidWith")}</span>
              <span className="text-lg font-bold text-font-active">{t("Landing.decor.points", { value: "18,500" })}</span>
            </div>
          </div>
        </div>
      </VoucherCard>
    </div>
  );
}
